module.exports = __webpack_public_path__ + "static/media/charger-pin-high-power.f3dc5451.svg";